import { IEdTabsMenu } from '@/content/interfaces/ed-tabs-menu.interface';
import { SECTION_TYPES } from '@/content/values/sections';
import {_HOMEWORKS_STORE, HOMEWORK_STATUS} from '@/homework/values/homeworks.values';
import Component from 'vue-class-component';
import { Mixins, Watch } from 'vue-property-decorator';
import { HomeworkPdfDraw } from '@/courses/mixins/homework-pdf-draw.mixin';
import EdFileViewer from '@/content/components/ed-file-viewer/ed-file-viewer.vue';
import { CourseHomeworkSplitObjectMixin } from '@/courses/mixins/course-homework-split-object.mixin';
import { SEND_CURRENT_SHARED_TASK_EVENT } from '@/content/values/ed-presentation-mode.values';

@Component({
  components: {
    EdFileViewer
  }
})
export default class EdHomeworkWriteObject extends Mixins(HomeworkPdfDraw , CourseHomeworkSplitObjectMixin) {

  public hasSplits : boolean = true;
  
  get hasPaperType(): boolean {
    return this.section.assetsInfo ? true : false;
  }

  get answer() {
    return this.hasPaperType ? { 
      type: SECTION_TYPES.LESSON_PDF.code,
      assetsInfo: this.section.assetsInfo,
      text: this.section.text
    } : null;
  }

  get answerUrl(): string {
    return this.hasPaperType ? this.section.assetsInfo[0].url : null;
  }

  get templates() : any[] {
    return this.hasPaperType ? [{
      name: this.$i18n.t('courses.objects.paperTemplate'),
      url: this.answerUrl
    }]: [];
  }

  setMenu() {    
    this.firstHorizontal = (this.hasPaperType || (!this.canResponse));
    this.menu = [{
      name: String(this.$i18n.t('courses.writeObject.problemTab')),
      contentId: this.contentsId.problem,
      active: !this.firstHorizontal,
      visible: true
    }];

    if(this.isShowTeacher && this.solution) {
      this.menu.push({
        name: String(this.$i18n.t('courses.writeObject.solutionTab')),
        contentId: this.contentsId.solution,
        active: false,
        visible: true
      });
    }
    
    if(this.hasPaperType || this.responseHomework){
      this.menu = this.menu.concat([{
        name: String(this.$i18n.t('courses.writeObject.responseTab')),
        contentId: this.contentsId.response,
        active: false,
        visible: true
      }]);
    }
    
    this.menu = this.menu.concat([{
      name: 'SplitHorizontal',
      contentId: this.contentsId.splitHorizontal,
      active: this.firstHorizontal,
      visible: false
    },{
      name: 'SplitVertical',
      contentId: this.contentsId.splitVertical,
      active: false,
      visible: false
    }]);
  }

  /* Watchers */
  @Watch('userModeForScreenMirroring', { immediate: false, deep: true })
  async reloadScreenMirroring() {
    await this.callPdf();
    this.setTab( this.hasPaperType ? this.contentsId.splitHorizontal : this.contentsId.problem);
  }

  setTab(contentId: string) {
    if (this.offlineMode) {
      return;
    }
    if( this.isScreenMirroringBookModeActive ) {
      this.settingTab({ contentId: this.contentsId.problem  , el: this.$refs.EdHomeworkWriteObjectTabs});
      this.hasSplits = false;
      this.menu.forEach(m => {
        m.visible = ( m.contentId === this.contentsId.problem );
      });
    } else if( this.isScreenMirroringPaperModeActive && ( this.hasPaperType || this.responseHomework ) ) {
      this.settingTab({ contentId: this.contentsId.response  , el: this.$refs.EdHomeworkWriteObjectTabs});
      this.hasSplits = false;
      this.menu.forEach(m => {
        m.visible = ( m.contentId === this.contentsId.response );
      });
    } else {
      this.hasSplits = true;
      this.settingTab({ contentId: contentId  , el: this.$refs.EdHomeworkWriteObjectTabs});
    }
  }

  changeTab(tab: IEdTabsMenu) {
    this.tabSelected = tab.contentId;
  }

  get canSendResponse(): boolean {

    if(typeof this.canResponse !== 'undefined') {
      return this.canResponse;
    } else {
      return this.section.status != HOMEWORK_STATUS.GRADED && this.section.status != HOMEWORK_STATUS.FINISHED;
    }
  }

  mounted() {
    if(this.firstHorizontal) {
      this.setTab(this.contentsId.splitHorizontal); 
    } else {
      this.tabSelected = this.contentsId.problem;
    }

    if(this.canSendResponse) {
      this.callPdf();
    } else{
      this.cancelLoading();
      if(this.isPublisher && this.isPresentationTeacherMode){
        this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.UPDATE_SELETED_BOARD_INFO, {});
        this.$edEventBus.$emit(SEND_CURRENT_SHARED_TASK_EVENT);
      }
    }
  }

  created() {
    this.setFiles();
    this.setMenu();
    this.setMenuSplit(this.isShowTeacher);
  } 

}